import * as Sentry from '@sentry/react';
import { getEnvironment, isSentryEnabled } from '@/lib/featureFlags';

const RELEASE_VERSION: string = (import.meta.env.VITE_APP_VERSION as string) || '0.1.0';
const GIT_COMMIT: string = ((import.meta.env.VITE_GIT_COMMIT as string) || '').substring(0, 7);

function buildRelease(): string {
  return GIT_COMMIT
    ? `trackers-v2-frontend@${RELEASE_VERSION}+${GIT_COMMIT}`
    : `trackers-v2-frontend@${RELEASE_VERSION}`;
}

export function initSentry(): void {
  if (!isSentryEnabled()) {
    return;
  }

  const dsn = import.meta.env.VITE_SENTRY_DSN as string | undefined;
  if (!dsn) {
    return;
  }

  Sentry.init({
    dsn,
    environment: getEnvironment(),
    release: buildRelease(),
    enabled: true,
    sampleRate: 1.0,
    tracesSampleRate: 0.1,
    sendDefaultPii: false,
    integrations: [Sentry.browserTracingIntegration()],
    ignoreErrors: [
      'Network Error',
      'NetworkError',
      'fetch failed',
      'Load failed',
      'AbortError',
      'ResizeObserver loop limit exceeded',
      'Non-Error promise rejection captured',
    ],
    beforeSend(event) {
      if (event.request?.headers) {
        delete (event.request.headers as Record<string, unknown>).authorization;
        delete (event.request.headers as Record<string, unknown>).cookie;
      }
      return event;
    },
    initialScope: {
      tags: { component: 'frontend', project: 'trackers-v2' },
    },
  });
}

export function setSentryUser(
  user: {
    id: string;
    email?: string;
    tenantId?: string;
  } | null
): void {
  if (!isSentryEnabled()) {
    return;
  }
  if (user === null) {
    Sentry.setUser(null);
    return;
  }
  Sentry.setUser({
    id: user.id,
    email: user.email,
    tenant_id: user.tenantId,
  });
}

export { Sentry };
